import React from 'react';
import api from '../api/client';
import withRouter from '../withRouter';

class OrderStatusPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { order: null, loading: true, polling: null };
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const reference = params.get('ref');
    if (!reference) return this.setState({ loading: false });

    this.reference = reference;
    this.poll();
    const interval = setInterval(this.poll, 4000);
    this.setState({ polling: interval });
  }

  componentWillUnmount() {
    if (this.state.polling) clearInterval(this.state.polling);
  }

  poll = () => {
    api.getOrderStatus(this.reference)
      .then((order) => {
        this.setState({ order, loading: false });
        if (['paid', 'fulfilled', 'failed'].includes(order.status) && this.state.polling) {
          clearInterval(this.state.polling);
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  render() {
    const { order, loading } = this.state;
    if (loading) return <p className="loading">Checking order status...</p>;
    if (!order) return <p>Order not found.</p>;

    return (
      <div className="order-status-page">
        <h1>Order {order.payment_reference}</h1>
        <p>Status: <strong>{order.status}</strong></p>
        {order.status === 'pending' && <p>Waiting for payment confirmation. This page updates automatically.</p>}
        {order.status === 'fulfilled' && <p>Payment confirmed — check your email for license details.</p>}
        {order.status === 'failed' && <p>Payment failed. Please try again from your cart.</p>}
      </div>
    );
  }
}

export default withRouter(OrderStatusPage);
